$(document).ready(function(){
           setTimeout( function () {
          var subscription_value = $('.subscription-radio .rc-radio__subscription').text();
              $('.onetime-radio .rc-radio__label').html('<strong>One-time purchase</strong>');
              $('.subscription-radio .rc-radio__subscription').html('<strong>'+subscription_value+'</strong>');
               $('.onetime-radio .rc-radio__label').after('<p class="u-h6 Guarantee__Text">No Subscription</p>');
               $('.subscription-radio .rc-radio__label').after('<p class="u-h6 Guarantee__Text">Pause & cancel anytime.</p>');
               var Product_price = $('.ProductOTP-Price').text();
              $('.onetime-radio .rc-radio__label').after('<span class="rc-radio__price_one"><strong>'+Product_price+'</strong></span>');
              var onetime_servingprice = $('.ontime-priceserving').text();
              $('.onetime-radio .Guarantee__Text').after('<p class="onetime_priceWrapper">($'+ onetime_servingprice +'/serving)</p>');
               var subscription_servingprice = $('.subscription-priceserving').text();
              $('.subscription-radio .Guarantee__Text').after('<p class="subscribe_priceWrapper">($'+ subscription_servingprice +'/serving)</p>');
              $('.rc-radio__label .rc-radio__price').after('<span class="Subscription__Price Subscription_ComparisionPrice Heading u-h6 FontWeight_Six"></span>');
             if ($('.onetime-radio span.rc-radio__price_one').length > 0) {
          	  document.querySelector('.Subscription__Price.Subscription_ComparisionPrice').textContent = document.querySelector('.onetime-radio span.rc-radio__price_one').textContent.trim();
             };
            $('.oke-w-mediaGridModule .oke-media--linked').removeAttr("role");
            $('.oke-mediaStrip-container.oke-w-mediaStrip').removeAttr("role");
            $('.oke-media--linked').removeAttr("role");
           $('.oke-w-reviews-list-item').each(function() {
             var negativeReview = $(this).find('.oke-helpful-vote-button--negative .oke-helpful-vote-counter').text();
             var positiveReview = $(this).find('.oke-helpful-vote-button--positive .oke-helpful-vote-counter').text();
            $(this).find('.oke-helpful-vote-button--negative').attr('aria-label', negativeReview);
            $(this).find('.oke-helpful-vote-button--positive').attr('aria-label', positiveReview);
           });
          }, 1600);
        });
        $(window).load(function(){
             var recommondedrating = $('.oke-w-header-content-module--left .oke-w-recommendsModule .oke-w-recommendsModule-value').html();
            console.log(recommondedrating);
            var Rating_value = $('.oke-w-header-content-module--left .oke-w-ratingAverageModule .oke-w-ratingAverageModule-rating  .oke-w-ratingAverageModule-rating-average').html();
        setTimeout( function () {
         $('.oke-w-recommendsModule .oke-w-recommendsModule-value').remove();
         $('.oke-w-recommendsModule .oke-w-recommendsModule-text').before('<span class="oke-w-recommendsModule-value"><strong>'+ recommondedrating +'</strong></span>');
        $('.oke-w-selectAttr-item-title').remove();
         $('.oke-w-reviews-list-item .oke-w-selectAttr-item-value').before('<span class="oke-w-selectAttr-item-title"><strong>I DRINK PIQUE FOR</strong></span>');
           $('.oke-w-ratingAverageModule .oke-w-ratingAverageModule-rating  .oke-w-ratingAverageModule-rating-average').remove();
          $('.oke-w-ratingAverageModule .oke-w-ratingAverageModule-rating  .oke-w-ratingAverageModule-rating-stars').before('<span class="oke-w-ratingAverageModule-rating-average"><strong>'+ Rating_value +'</strong></span>');
        },500);
        })

document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".pt_456_tabs");
  const panels = document.querySelectorAll(".ProductIngre_TabPanel");

  // Default: show first panel
  panels.forEach((panel, index) => {
    panel.classList.toggle("visible", index === 0);
  });

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", function () {

      // Remove active class from all tabs
      tabs.forEach(t => t.classList.remove("pt_456_tabs_active"));

      // Add active class to clicked tab
      this.classList.add("pt_456_tabs_active");
      this.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });

      // Show only the matching panel
      panels.forEach((panel, i) => {
        panel.classList.toggle("visible", i === index);
      });

    });
  });

});

/* Product gallery slider Mobile */
!function () {
  "use strict";

  // Poll until a condition is met, then resolve. Times out after `timeout` ms.
  function waitFor(condition, timeout) {
    timeout = timeout || 10000;
    return new Promise(function (resolve) {
      var interval = setInterval(function () {
        if (condition()) {
          resolve(condition());
          clearInterval(interval);
          interval = null;
        }
      }, 500);
      setTimeout(function () {
        if (interval !== null) {
          clearInterval(interval);
          console.log("slider-width: condition not met before timeout");
        }
      }, timeout);
    });
  }

  function applyWidth() {
    var slideshow = document.querySelector(
      ".Product__Gallery .Product__Slideshow--zoomable"
    );
    if (!slideshow) return;

    // Set each cell to 83.333% width
    slideshow.querySelectorAll(".Carousel__Cell").forEach(function (cell) {
      cell.style.width = "83.333%";
    });

    // Resize Flickity so it recalculates positions with the new widths
    var flkty = Flickity.data(slideshow);
    if (flkty) flkty.resize();
  }

  waitFor(function () {
    return (
      window.innerWidth < 768 &&
      document.querySelector(
        ".Product__Gallery .Product__Slideshow--zoomable"
      ) != null && typeof Flickity === "function"
    );
  }).then(applyWidth);
}();


/* Product accordion to tab setup */
/* eslint-disable*/
!(function () {
  'use strict';

  function poll(predicate, timeoutMs) {
    timeoutMs = timeoutMs || 10000;
    return new Promise(function (resolve) {
      var id = setInterval(function () {
        var val = predicate();
        if (val) {
          resolve(val);
          clearInterval(id);
          id = null;
        }
      }, 500);
      setTimeout(function () {
        if (id !== null) {
          clearInterval(id);
          console.log('condition false');
        }
      }, timeoutMs);
    });
  }

  var CONFIG = {
    html: {
      calmWrapper: function (content) {
        return '<div class="pt_472_calm_wrapper">' + content + '</div>';
      },
      calmTags: function (content) {
        return '<div class="pt_472_calm">' + content + '</div>';
      },
      accorTags: function (content) {
        return '<div class="pt_472_accor">' + content + '</div>';
      },
      accordianWrapper: function (content) {
        return '<div class="pt_472_accordian_wrapper">' + content + '</div>';
      },
      accorPopupOverlay: '\n           <div class="pt_472_accordian_overlay"></div>',
      accorPopup: function (title, content) {
        return (
          '<div class="pt_472_accordian_popup">\n' +
          '                              <div class="pt_472_popup_header">\n' +
          '                                 <h3>' + title + '</h3>\n' +
          '                                 <div class="pt_472_popup_close"><img src="https://cdn.shopify.com/s/files/1/2135/4367/files/Close-popup.png?v=1791181491"></div>\n' +
          '                              </div>\n' +
          '                              <div class="pt_472_accorPopup_content Product__Tabs ProductDetail__Tab">\n' +
          '                                  ' + content + '\n' +
          '                              </div>\n' +
          '                     </div>'
        );
      },
      atcPopupOverlay: '<div class="pt_472_atc_overlay"></div>',
      atcPopup: function (title) {
        return (
          '<div class="pt_472_atc_popup">\n' +
          '                              <div class="pt_472_atc_header">\n' +
          '                                 <h3>' + title + '</h3>\n' +
          '                                 <div class="pt_472_atc_close"><img src="https://cdn.shopify.com/s/files/1/2135/4367/files/Close-popup.png?v=1791181491"></div>\n' +
          '                              </div>\n' +
          '                              <div class="pt_472_atc_content">\n' +
          '                              </div>\n' +
          '                     </div>'
        );
      },
      tooltipWrapper: function (title, content) {
        return (
          '\n                        <div class="pt_472_tooltip_wrapper">\n' +
          '                                <span class="pt_472_tool_icon"><img class="pt_472_tip_icon" src="https://cdn.shopify.com/s/files/1/2135/4367/files/info-icon_40x.png?v=1659418089"></span>\n' +
          '                                <div class="pt_472_tool_container">\n' +
          '                                    <div class="pt_472_tool_header">\n' +
          '                                          <h3 class="pt_472_tool_head">' + title + '</h3>\n' +
          '                                          <div class="pt_472_tooltip_close"><img src="https://cdn.shopify.com/s/files/1/2135/4367/files/Close-popup.png?v=1791181491"></div>\n' +
          '                                    </div>\n' +
          '                                    <div class="pt_472_tool_cont Product__Tabs ProductDetail__Tab">' + content + '</div>\n' +
          '                                </div>\n' +
          '                        </div>\n' +
          '                     '
        );
      },
    },
  };

  function delegate(el, event, selector, handler) {
    el.addEventListener(event, function (e) {
      var target = e.target;
      while (target && target !== this) {
        if (target.matches(selector)) {
          e.matchedSelector = target;
          handler.call(target, e);
        }
        target = target.parentNode;
      }
    });
  }

  /* Universal anchor/buybox-shape helpers — shared by the accordion and
     sticky-ATC-popup setups below, so neither hard-codes ".liquid". */
  function findBuyboxAnchor(container, preferLastOfType) {
    return (
      (preferLastOfType && container.querySelector('.Container .ProductForm .liquid:last-of-type')) ||
      container.querySelector('.Container .ProductForm .liquid') ||
      container.querySelector('.Container .ProductForm .pt_option_group') ||
      container.querySelector('.ProductForm .ProductForm__AddToCart')
    );
  }

  var initAll = function (container) {
    /* 1. Move ProductMeta above the gallery — unchanged, no .liquid dependency */
    (function (c) {
      poll(function () {
        return (
          c.querySelector('.Product__Wrapper .Product__Gallery--withThumbnails') != null &&
          c.querySelector('.Container > .ProductMeta') != null
        );
      }).then(function () {
        c.querySelector('.Product__Wrapper .Product__Gallery--withThumbnails').insertAdjacentElement(
          'beforebegin',
          c.querySelector('.Container > .ProductMeta')
        );
      });
    })(container);

    /* 2. Zoom carousel cell width fix — unchanged */
    (function (c) {
      poll(function () {
        return c.querySelector('.Product__Gallery .Product__Slideshow--zoomable') != null && typeof Flickity === 'function';
      }).then(function () {
        var el = c.querySelector('.Product__Gallery .Product__Slideshow--zoomable');
        var flkty = Flickity.data(el);
        if (flkty) {
          el.querySelectorAll('.Carousel__Cell').forEach(function (cell) {
            cell.style.width = '83.333%';
          });
          flkty.resize();
        }
      });
    })(container);

    /* 3. Accordion tabs — anchor no longer hard-requires .liquid */
    (function (c) {
      var isCacaoChai = window.location.pathname === '/products/cacao-chai';
      var isNandaka14ct = window.location.pathname === '/products/nandaka-coffee-alternative-14ct';

      poll(function () {
        return (
          c.querySelector('.Product__Tabs button.Collapsible__Button') != null &&
          c.querySelector('.ProductForm ~ .ProductMeta__Description') != null &&
          c.querySelector('.footbar-fixed-product .Sticky__Form') != null &&
          c.querySelector('.ProductForm .ProductForm__AddToCart') != null
        );
      }).then(function () {
        if (c.querySelector('.pt_472_accordian_wrapper')) return;

        var anchorEl;
        if (isCacaoChai) {
          c.classList.add('pt_472_cacao_chai_pdp');
          anchorEl = c.querySelector('.ProductForm .ProductForm__AddToCart');
        } else {
          anchorEl = findBuyboxAnchor(c, isNandaka14ct);
        }
        if (!anchorEl) return; // nothing sensible to anchor to — bail quietly, don't throw

        var stickyForm = c.querySelector('.footbar-fixed-product .Sticky__Form');
        var tabsHTML = '';

        function closeAccordionPopup() {
          var overlay = c.querySelector('.pt_472_accordian_overlay');
          var popup = c.querySelector('.pt_472_accordian_popup');
          if (overlay) overlay.classList.remove('pt_472_accordian_active');
          if (popup) popup.classList.remove('pt_472_accordian_active');
          c.classList.remove('pt_472_accor_popup_open');
        }

        tabsHTML += '<div class="pt_472_accor pt_472_accor_active">Benefits</div>';
        c.querySelectorAll('.Product__Tabs button.Collapsible__Button').forEach(function (btn) {
          var label = btn.textContent.trim().toLowerCase();
          tabsHTML += CONFIG.html.accorTags(label);
        });

        c.insertAdjacentHTML('beforeend', CONFIG.html.accorPopupOverlay);
        anchorEl.insertAdjacentHTML('beforebegin', CONFIG.html.accordianWrapper(tabsHTML));
        if (stickyForm) stickyForm.insertAdjacentHTML('afterbegin', CONFIG.html.accordianWrapper(tabsHTML));

        c.querySelectorAll('.pt_472_accor').forEach(function (tab) {
          tab.addEventListener('click', function () {
            var label = this.textContent.trim().toLowerCase();
            c.querySelectorAll('.pt_472_accor').forEach(function (t) {
              t.classList.remove('pt_472_accor_active');
            });
            c.querySelectorAll('.pt_472_accor').forEach(function (t) {
              if (t.textContent.trim().toLowerCase() === label) t.classList.add('pt_472_accor_active');
            });

            var title = label;
            var bodyHTML = '';
            if (label === 'benefit' || label === 'benefits') {
              title = 'Benefits';
              var desc = c.querySelector('.ProductForm ~ .ProductMeta__Description');
              bodyHTML = desc ? desc.outerHTML : '';
            } else {
              var match = Array.from(c.querySelectorAll('.Product__Tabs .Collapsible__Button')).find(function (b) {
                return b.textContent.trim().toLowerCase() === label.toLowerCase();
              });
              if (match) {
                var contentEl = match.closest('.Collapsible').querySelector('.Collapsible__Content');
                bodyHTML = contentEl ? contentEl.outerHTML : '';
              }
            }

            var overlay = c.querySelector('.pt_472_accordian_overlay');
            var popup = c.querySelector('.pt_472_accordian_popup');
            if (popup) {
              popup.querySelector('.pt_472_popup_header h3').textContent = title;
              popup.querySelector('.pt_472_accorPopup_content').innerHTML = bodyHTML;
            } else {
              c.insertAdjacentHTML('beforeend', CONFIG.html.accorPopup(title, bodyHTML));
              popup = c.querySelector('.pt_472_accordian_popup');
              popup.querySelector('.pt_472_popup_close').addEventListener('click', closeAccordionPopup);
              if (overlay) overlay.addEventListener('click', closeAccordionPopup);
            }
            if (overlay) overlay.classList.add('pt_472_accordian_active');
            popup.classList.add('pt_472_accordian_active');
            c.classList.add('pt_472_accor_popup_open');
          });
        });

        delegate(document, 'click', 'body', function (e) {
          if (e.target.closest('.pt_472_accorPopup_content a.okeReviews-reviewsCarousel-btn')) {
            var realReviewBtn = c.querySelector('.Container > .ProductDetail__Tab a.okeReviews-reviewsCarousel-btn');
            if (realReviewBtn) realReviewBtn.click();
          }
        });
      });
    })(container);

    /* 4. Sticky Add-to-Cart popup — the main fix is here */
    (function (o) {
      var isCacaoChai = window.location.pathname === '/products/cacao-chai';

      poll(function () {
        return o.querySelector('.Sticky__Form > .Container') != null && o.querySelector('.ProductForm button.ProductForm__AddToCart') != null;
      }).then(function () {
        if (o.querySelector('.pt_472_atc_popup')) return;

        var realATCBtn = o.querySelector('.ProductForm button.ProductForm__AddToCart');
        if (realATCBtn) {
          var stickyClone = realATCBtn.cloneNode(true);
          stickyClone.classList.add('pt_472_is_sticky_clone');
          stickyClone.type = 'button';
          stickyClone.classList.remove('ProductForm__AddToCart');
          o.querySelector('.Sticky__Form > .Container').insertAdjacentElement('afterbegin', stickyClone);
        }

        var titleEl = o.querySelector('.ProductMeta .ProductMeta__Title');
        var productTitle = titleEl ? titleEl.textContent.trim() : '';
        var realForm = o.querySelector('.Container form.ProductForm');
        var formClone = realForm ? realForm.cloneNode(true) : null;

        function openATCPopup() {
          var overlay = o.querySelector('.pt_472_atc_overlay');
          var popup = o.querySelector('.pt_472_atc_popup');
          if (overlay) overlay.classList.add('pt_472_atc_active');
          if (popup) popup.classList.add('pt_472_atc_active');
          o.classList.add('pt_472_atc_open');
        }
        function closeATCPopup() {
          var overlay = o.querySelector('.pt_472_atc_overlay');
          var popup = o.querySelector('.pt_472_atc_popup');
          if (overlay) overlay.classList.remove('pt_472_atc_active');
          if (popup) popup.classList.remove('pt_472_atc_active');
          o.classList.remove('pt_472_atc_open');
        }

        o.insertAdjacentHTML('beforeend', CONFIG.html.atcPopupOverlay);
        o.insertAdjacentHTML('beforeend', CONFIG.html.atcPopup(productTitle));
        var popupContent = o.querySelector('.pt_472_atc_content');
        if (formClone) popupContent.appendChild(formClone);

        if (!isCacaoChai) {
          var stickyCloneEl = o.querySelector('.Sticky__Form .pt_472_is_sticky_clone');
          if (stickyCloneEl) stickyCloneEl.addEventListener('click', openATCPopup);
        }
        var closeBtn = o.querySelector('.pt_472_atc_close');
        if (closeBtn) closeBtn.addEventListener('click', closeATCPopup);
        var overlayEl = o.querySelector('.pt_472_atc_overlay');
        if (overlayEl) overlayEl.addEventListener('click', closeATCPopup);

        if (isCacaoChai) {
          var cacaoStickyBtn = o.querySelector('.pt_472_is_sticky_clone');
          if (cacaoStickyBtn) {
            cacaoStickyBtn.addEventListener('click', function (e) {
              e.preventDefault();
              var realBtn = o.querySelector('.Product__InfoWrapper .ProductForm__AddToCart');
              if (realBtn) realBtn.click();
            });
          }
          return; // cacao-chai's flow ends here, same as the original script
        }

        function getRealForm() {
          return o.querySelector('.Container > form.ProductForm');
        }

        var realFormForDetection = getRealForm();
        var usesNewDesign = !!(realFormForDetection && realFormForDetection.querySelector('.pt_option_group'));

        if (usesNewDesign) {
          /* ---- NEW design (.pt_option_group) ---- */

          function activateIntentOnReal(intent) {
            var form = getRealForm();
            if (!form) return;
            var label = form.querySelector(intent === 'onetime' ? '.pt_option--onetime' : '.pt_option--subscribe');
            var radio = label && label.querySelector('.pt_option_radio_input');
            if (radio && !radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

          function mirrorIntentIntoClone(intent) {
            var subLabel = popupContent.querySelector('.pt_option--subscribe');
            var oneLabel = popupContent.querySelector('.pt_option--onetime');
            if (!subLabel || !oneLabel) return;
            subLabel.classList.toggle('is-selected', intent === 'subscription');
            oneLabel.classList.toggle('is-selected', intent === 'onetime');
            var subRadio = subLabel.querySelector('.pt_option_radio_input');
            var oneRadio = oneLabel.querySelector('.pt_option_radio_input');
            if (subRadio) subRadio.checked = intent === 'subscription';
            if (oneRadio) oneRadio.checked = intent === 'onetime';

            var priceSource = intent === 'subscription' ? subRadio : oneRadio;
            var atcPrice = priceSource && priceSource.getAttribute('data-atc-price');
            if (atcPrice) {
              var atcPriceEl = popupContent.querySelector('.Quantity__PriceBtn, .pt396_addToCart_button_price');
              if (atcPriceEl) atcPriceEl.textContent = atcPrice;
            }
          }

          popupContent.addEventListener('click', function (e) {
            var wantsSubscriptionCTA = e.target.closest('.pt_switch_link, [data-switch-to="subscribe"]');
            var wantsOnetime = !wantsSubscriptionCTA && e.target.closest('.pt_option--onetime');
            var wantsSubscription = wantsSubscriptionCTA || e.target.closest('.pt_option--subscribe');
            if (!wantsOnetime && !wantsSubscription) return;
            var intent = wantsSubscription ? 'subscription' : 'onetime';
            activateIntentOnReal(intent);
            mirrorIntentIntoClone(intent);
          });

          var initialSubRadio = realFormForDetection.querySelector('.pt_option--subscribe .pt_option_radio_input');
          mirrorIntentIntoClone(initialSubRadio && initialSubRadio.checked ? 'subscription' : 'onetime');
        } else {
          /* ---- OLD design (.pt_413_*) — restored verbatim from the
             original script, each step individually null-guarded so a
             missing element skips just that step instead of throwing. ---- */

          var cloneOnetimeWrapper = popupContent.querySelector('.pt_413_onetime_wrapper');
          if (cloneOnetimeWrapper) cloneOnetimeWrapper.classList.remove('pt_413_hidden');

          var stickyCheckbox = o.querySelector('#sticky_toggleCheckbox');
          if (stickyCheckbox) {
            if (!stickyCheckbox.checked) o.classList.add('stickyToogle_enabled');
            stickyCheckbox.addEventListener('change', function (e) {
              o.classList.toggle('stickyToogle_enabled', !e.target.checked);
            });
          }

          var realSwitchCTA = realFormForDetection && realFormForDetection.querySelector('p.pt_413_onetime_left_lower_cta');
          if (realSwitchCTA) {
            realSwitchCTA.addEventListener('click', function () {
              var realToggleSwitch = realFormForDetection.querySelector('.pt_413_onetime_wrapper .pt_413_toggle_switch');
              if (realToggleSwitch) realToggleSwitch.click();
            });
          }

          popupContent.addEventListener('click', function (e) {
            var target = e.target;
            if ((target.closest('.pt_413_onetime_wrapper') || target.closest('.pt_413_subscription_wrapper')) && stickyCheckbox) {
              var lbl = stickyCheckbox.closest('label[for="sticky_toggleCheckbox"]');
              if (lbl) lbl.click();
            }
          });
        }

        /* THE CRITICAL PART: this now runs unconditionally, regardless of
           which buybox design is present, since it's what makes "Add to
           Cart" inside the popup actually work at all. In the original
           script this was unreachable on AU/HK/SG because of the thrown
           error earlier in this same block. */
        var popupATCBtn = popupContent.querySelector('button.ProductForm__AddToCart');
        if (popupATCBtn) {
          popupATCBtn.addEventListener('click', function (e) {
            e.preventDefault();
            poll(function () {
              var form = getRealForm();
              return form && form.querySelector('button.ProductForm__AddToCart') != null;
            }).then(function () {
              getRealForm().querySelector('button.ProductForm__AddToCart').click();
            });
          });
        }
      });
    })(container);

    /* 5. Benefit-tag gallery overlay positioning — unchanged, no .liquid dependency */
    (function (o) {
      poll(function () {
        return (
          o.querySelector('.Container > .ProductMeta__Tags ul.Linklist li.Linklist__Item') != null &&
          o.querySelector('main .Product__Slideshow .flickity-slider .Product__SlideItem[data-media-position="1"] .AspectRatio') != null &&
          typeof Flickity === 'function'
        );
      }).then(function () {
        var tags = o.querySelectorAll('.Container > .ProductMeta__Tags ul.Linklist li.Linklist__Item');
        var slide1 = o.querySelector('main .Product__Slideshow .flickity-slider .Product__SlideItem[data-media-position="1"] .AspectRatio');
        if (tags.length && slide1 && !o.querySelector('.pt_472_calm_wrapper')) {
          var tagsHTML = '';
          tags.forEach(function (tag) {
            tagsHTML += CONFIG.html.calmTags(tag.textContent.trim());
          });
          slide1.insertAdjacentHTML('afterbegin', CONFIG.html.calmWrapper(tagsHTML));
        }
      });

      poll(function () {
        return (
          o.querySelector('main .Product__Slideshow .flickity-slider .Product__SlideItem[data-media-position="2"] .pt_472_calm_wrapper') != null &&
          typeof Flickity === 'function'
        );
      }).then(function () {
        var slide1 = o.querySelector('main .Product__Slideshow .flickity-slider .Product__SlideItem[data-media-position="1"] .AspectRatio');
        var wrongSlideWrapper = o.querySelector('main .Product__Slideshow .flickity-slider .Product__SlideItem[data-media-position="2"] .pt_472_calm_wrapper');
        if (slide1 && wrongSlideWrapper) {
          slide1.insertAdjacentElement('afterbegin', wrongSlideWrapper);
        }
        var leftover = o.querySelector('main .Product__Slideshow .flickity-slider .Product__SlideItem[data-media-position="2"] .pt_472_calm_wrapper');
        if (leftover) leftover.remove();
      });

      poll(function () {
        return (
          o.querySelector('main .Product__Slideshow .flickity-slider .Product__SlideItem[data-media-position="1"] .pt_472_calm_wrapper') != null &&
          o.querySelector('main .Product__Slideshow .flickity-viewport > .pt_461_benefits_tag') != null &&
          typeof Flickity === 'function'
        );
      }).then(function () {
        var dupe = o.querySelector('main .Product__Slideshow .flickity-slider .Product__SlideItem[data-media-position="1"] .pt_472_calm_wrapper');
        if (dupe) dupe.remove();
      });

      poll(function () {
        return (
          o.querySelector('main .Product__Slideshow .flickity-slider .Product__SlideItem[data-media-position="1"] .pt_461_benefits_tag') != null &&
          o.querySelector('main .Product__Slideshow .flickity-slider .Product__SlideItem[data-media-position="1"] .pt_472_calm_wrapper') != null &&
          typeof Flickity === 'function'
        );
      }).then(function () {
        var dupe = o.querySelector('main .Product__Slideshow .flickity-slider .Product__SlideItem[data-media-position="1"] .pt_472_calm_wrapper');
        if (dupe) dupe.remove();
      });
    })(container);

    /* 6. Hide duplicate "100% happiness guarantee" accordion tab — unchanged */
    (function (c) {
      poll(function () {
        return c.querySelectorAll('.pt_472_accor').length > 1;
      }).then(function () {
        c.querySelectorAll('.pt_472_accor').forEach(function (tab) {
          if (tab.textContent.trim().toLowerCase() === '100% happiness guarantee') {
            tab.classList.add('pt_472_hide_guarantee_acc');
          }
        });
      });
    })(container);

    /* 7. Guarantee tooltip — unchanged */
    (function (o) {
      poll(function () {
        return (
          o.querySelector('.Product__Tabs button.Collapsible__Button') != null &&
          o.querySelector('.Product__InfoWrapper > .Product__Info > .Container > form.ProductForm > .Guarantee__Text') != null
        );
      }).then(function () {
        o.querySelectorAll('.Product__Tabs button.Collapsible__Button').forEach(function (btn) {
          if (btn.textContent.replace(/\s+/g, ' ').trim().toLowerCase().includes('100% happiness guarantee')) {
            var content = btn.closest('.Collapsible').querySelector('.Collapsible__Content');
            if (content) {
              var contentHTML = content.outerHTML;
              var guaranteeText = o.querySelector('.Product__InfoWrapper > .Product__Info > .Container > form.ProductForm > .Guarantee__Text');
              if (!o.querySelector('.pt_tooltip_wrapper') && guaranteeText) {
                guaranteeText.insertAdjacentHTML('beforeend', CONFIG.html.tooltipWrapper('100% Happiness Guarantee', contentHTML));
              }
            }
          }
        });

        o.addEventListener('click', function (e) {
          var icon = e.target.closest('.pt_472_tool_icon');
          if (icon) icon.closest('.pt_472_tooltip_wrapper').classList.add('pt_472_active_tool');

          var closeBtn = e.target.closest('.pt_472_tooltip_close');
          if (closeBtn) closeBtn.closest('.pt_472_tooltip_wrapper').classList.remove('pt_472_active_tool');

          var activeTooltip = o.querySelector('.pt_472_tooltip_wrapper.pt_472_active_tool');
          if (activeTooltip && !e.target.closest('.pt_472_tooltip_wrapper')) {
            activeTooltip.classList.remove('pt_472_active_tool');
          }
        });
      });
    })(container);

    /* 8. Carrara-specific class — unchanged */
    if (window.location.pathname === '/products/carrara' || window.location.pathname === '/products/mothers-day-carrara-matcha-bundle') {
      container.classList.add('pt_472_carara_pdp');
    }
  };

  /* Bootstrap — unchanged */
  (function () {
    window.optiActiveTests = window.optiActiveTests || {};
    window.optiActiveTests['OP_PT_472'] = 'v1';

    poll(function () {
      return window.location.pathname.includes('/products/') && window.innerWidth < 768 && document.querySelector('main') !== null;
    }).then(function () {
      var body = document.body;
      body.classList.add('pt_472');
      initAll(body);
    });
  })();
})();

document.addEventListener('change', function (e) {
  var select = e.target.closest('.SellingPlan__Selector');
  if (!select) return;
  var popupContent = select.closest('.pt_472_atc_content');
  var realForm = document.querySelector('.Container > form.ProductForm');
  var targetScope = (popupContent && realForm)
    ? realForm
    : (select.closest('[class*="bundleBaseCol"]') || select.closest('form') || document);

  var hiddenInput = targetScope.querySelector('input[name="selling_plan"]');
  if (hiddenInput) hiddenInput.value = select.value;
  if (popupContent) {
    var popupHiddenInput = popupContent.querySelector('input[name="selling_plan"]');
    if (popupHiddenInput) popupHiddenInput.value = select.value;
  }
});

/* Convert test 163 */
if (!window.op_pt_485_var_code_triggered) {
    window.op_pt_485_var_code_triggered = true;
    !function(){"use strict";!function(){function t(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:2e4;return new Promise(function(n){var r=setInterval(function(){t()&&(n(t()),clearInterval(r),r=null)},100);setTimeout(function(){null!==r&&(clearInterval(r),console.log("condition false"))},e)})}var e=function(t,e){return t?console.log.bind(console,"".concat(e,":")):function(){}};function n(t){return function(t){if(Array.isArray(t))return r(t)}(t)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||function(t,e){if(t){if("string"==typeof t)return r(t,e);var n={}.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?r(t,e):void 0}}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function r(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=Array(e);n<e;n++)r[n]=t[n];return r}function pt485EagerLoadFirstSlide(e){var n=e.querySelector('.Product__Gallery .Product__Slideshow--zoomable .Carousel__Cell:first-child img.Image--lazyLoad');n&&(n.setAttribute("fetchpriority","high"),n.setAttribute("decoding","async"),n.dataset.src&&n.getAttribute("src")!==n.dataset.src&&(n.src=n.dataset.src))}var o=function(t){var e=n(t.closest(".pt_472_accordian_wrapper").querySelectorAll(".pt_472_accor")),r=e.find(function(t){return t.textContent.trim().toLowerCase().includes("ingredients")}),o=e.find(function(t){return t.textContent.trim().toLowerCase().includes("how to")});r&&o&&!o.contains(r)&&!r.contains(o)&&o.insertAdjacentElement("afterend",r)},i=function(t){var e=t.querySelector(".pt_461_benefits_tag"),n=e.closest(".Carousel"),r=window.Flickity.data(n);r.on("dragStart",function(){0===r.selectedIndex&&e.classList.add("pt_485_fade-out_tags")}),r.on("dragEnd",function(){0===r.selectedIndex&&e.classList.remove("pt_485_fade-out_tags")}),r.on("settle",function(){0===r.selectedIndex&&e.classList.remove("pt_485_fade-out_tags")})},a=function(t){var e=t.closest(".Carousel"),n=window.Flickity.data(e);n.options.wrapAround=!0,n.resize()},c=function(e){t(function(){return e.querySelector(".Product__Wrapper .Product__Meta-mobile")&&e.querySelector(".Product__Wrapper .Product__Gallery")}).then(function(){return function(e){var r=e.querySelector(".Product__Meta-mobile"),c=e.querySelector(".Product__Wrapper .Product__Gallery"),u="/products/bt-fountain"===window.location.pathname,l="/products/nectar-sweetener"===window.location.pathname;u&&e.classList.add("pt_485_btFountainProduct"),c.contains(r)||r.contains(c)||c.insertAdjacentElement("afterend",r),t(function(){return c.querySelector(".Carousel.flickity-enabled")}).then(function(t){a(t)}),!l||l&&e.querySelector('.Carousel [data-media-position="1"] .pt_461_benefits_tag')?t(function(){return c.querySelector(".Carousel.flickity-enabled")&&c.querySelector(".Carousel .pt_461_benefits_tag")}).then(function(t){t.closest('[data-media-position="1"]')&&i(e)}):t(function(){return c.querySelector(".Carousel.flickity-enabled")&&c.querySelector('.Carousel [data-media-position="1"] div')}).then(function(t){var r=n(e.querySelectorAll(".ProductMeta .ProductMeta__Tags .Collection__Title")).slice(0,3);t.insertAdjacentHTML("afterbegin",'<div class="pt_461_benefits_tag"></div>');var o=r.map(function(t){return"<span>".concat(t.textContent.trim(),"</span>")}).join("");e.querySelector('.Carousel [data-media-position="1"] .pt_461_benefits_tag').insertAdjacentHTML("afterbegin",o),i(e)}),function(t){t.addEventListener("click",function(t){var e=t.target.closest(".pt_472_accordian_popup .okeReviews-reviewsCarousel-btn");if(e){var n=e.closest(".pt_472_accordian_popup").querySelector(".pt_472_popup_close");n&&n.click()}})}(e),t(function(){return e.querySelector(".Product__Wrapper .pt_472_accordian_wrapper .pt_472_accor")}).then(o),t(function(){return e.querySelector(".Sticky__Form .pt_472_accordian_wrapper .pt_472_accor")}).then(o)}(e)})};!function(n){!function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"v1";window.optiActiveTests=window.optiActiveTests||{},window.optiActiveTests[t]=e}(n,"v1");var r=e(!0,n);t(function(){return document.querySelector("body")}).then(function(t){window.innerWidth>767||!window.location.pathname.includes("/products/")||(t.classList.add("pt_485"),r("workflow fn called"),c(t))})}("PT_485")}()}();
}